// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"17":"27a79858","384":"f2a77639","870":"4c3b3728"}[chunkId] + ".chunk.css";
};